import { PRE_ONBOARDING_STEPS } from '@constants/userFlow';
import { OnboardingSplitLayout } from '@components/auth/OnboardingSplitLayout';
import { useAdvanceOnboardingStep } from './steps/useAdvanceOnboardingStep';
import { useOnboardingBack } from './steps/useOnboardingBack';
import { useOnboardingDraftStore } from '@stores/onboardingDraftStore';
import SetupCompleteIllustration from '../../assets/images/onboarding/setup-complete-illustration.png';

/**
 * Onboarding 2.0 — final "You're set up!" step (Figma 20045:8157). Marks
 * REGISTER_COMPLETED and drops the merchant into the dashboard. `advance`
 * short-circuits to /home once REGISTER_COMPLETED is recorded, so the guard
 * never pulls the user back into the funnel. Right side is the live-storefront
 * illustration (Figma "setup 1").
 */
export default function WelcomeOnboardPage() {
  const onBack = useOnboardingBack();
  const { advance, isSubmitting } = useAdvanceOnboardingStep(
    PRE_ONBOARDING_STEPS.REGISTER_COMPLETED
  );

  return (
    <OnboardingSplitLayout
      showLogo
      onBack={onBack}
      illustration={
        <img
          src={SetupCompleteIllustration}
          alt="Your website is live"
          className="w-full max-w-[760px] object-contain"
        />
      }
    >
      <h1 className="text-[40px] font-bold leading-[1.15] text-[#101828]">
        You&rsquo;re <span className="text-[#6b33ff]">set up!</span>
      </h1>
      <p className="mt-4 max-w-[336px] text-[18px] leading-[28px] text-[#475467]">
        Your 14-day free trial starts today.
      </p>

      <div className="mt-10">
        <button
          type="button"
          onClick={() => {
            useOnboardingDraftStore.getState().reset();
            void advance();
          }}
          disabled={isSubmitting}
          className="inline-flex h-[60px] w-full items-center justify-center gap-2 rounded-[12px] bg-[#6b33ff] text-[18px] font-semibold text-white transition hover:bg-[#5a29e0] disabled:cursor-not-allowed disabled:opacity-60 lg:w-[230px]"
        >
          {isSubmitting && (
            <span className="h-5 w-5 animate-spin rounded-full border-2 border-white/40 border-t-white" />
          )}
          Go to Dashboard
        </button>
      </div>
    </OnboardingSplitLayout>
  );
}
